import ResizeBar from './resize-bar';

export default ResizeBar;
